module.exports = __webpack_public_path__ + "static/assets/afc4712654f525de562789f034929bbd.gif";